import { css } from '@linaria/atomic';
import { cx } from '@linaria/atomic';
import { ListboxOption } from './listbox-option.component';
import type { ListboxProps } from './listbox.component';
import { Listbox } from './listbox.component';
import { useListboxSearch } from './use-listbox-search';

const searchableListboxContainer = css`
  display: flex;
  flex-direction: column;
`;

export const SearchableListbox = ({ children, className, ...rest }: ListboxProps) => {
  const { SearchField, searchFieldProps, matchingChildren } = useListboxSearch(children);
  return (
    <div className={cx(searchableListboxContainer, className)}>
      <SearchField {...searchFieldProps} name='lb-search' />
      <Listbox {...rest}>{matchingChildren}</Listbox>
    </div>
  );
};

SearchableListbox.Option = ListboxOption;
